import type { FaireProductEntity } from "../../entity_types/product";

export const p_sqmtmtngbt: FaireProductEntity = {
  token: "p_sqmtmtngbt",
  type: "product",
  name: "Solid Bubble Textured Large Tote Bag",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c5c92533465a4369ec9fe16567e56bdbe317231b3a066332c4477c996f14a80a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e71cbaa98c77e162bf2f1c3fe3bb5d72725bff6bac6538dfced26c032315203.jpeg",
    "https://cdn.faire.com/fastly/1b4398ea7e99f9ce54f8f7a87dc251a79d1f04600908044efdfe9d17d2e96e96.jpeg",
    "https://cdn.faire.com/fastly/0eb65ad77d2fe799567700dbf6357eeae984b2a9408ee63f74eafecfe65b4737.jpeg",
    "https://cdn.faire.com/fastly/67921e241b6cca2bd8b3ded23a9dbd8ff821daa411fe280c407cf3df157a38de.jpeg",
    "https://cdn.faire.com/fastly/941bc0842d8331edfd95549a19876ce59b77e0ad66cc2d8b5de260a019ddd314.jpeg",
    "https://cdn.faire.com/fastly/cb83bf241fd01357b0db4de8d1264c9f20f9df9da828fca3f9f2797968b39c38.jpeg",
    "https://cdn.faire.com/fastly/f7056e4e1c4140fdb704f7691bcacfd0d2bb124d342712a3019d3fd0fa3f17a6.jpeg",
    "https://cdn.faire.com/fastly/98e752e5839efff7ee69a32ec18603ea50ec232cb66e94bda6e0c1872bd3677d.jpeg",
    "https://cdn.faire.com/fastly/501412bfee1744c3be4b83215e1eedec2085e5cfbd995d8cb85bff9ea23b4e5e.jpeg",
  ],
  priceDollars: 6.24,
  description:
    '🎀Material: 95%PU+5%Alloy\n😍Why You’ll Love It?\n\nTrendy "bubble" or popcorn texture creates a unique, high-fashion 3D effect across the entire bag.\nSpacious interior and large silhouette make it an ideal choice for daily commuting, gym gear, or weekend travel.\nFeatures integrated wide shoulder straps designed for maximum comfort and durability during carry.\nSoft, flexible construction allows the bag to expand for extra storage while remaining lightweight.\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!\nGifts',
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:30.581Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
